__turbopack_context__.v({
  "container": "Grid-module-scss-module__Opa61q__container",
  "grid": "Grid-module-scss-module__Opa61q__grid",
  "row": "Grid-module-scss-module__Opa61q__row",
});
